import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';

import has from 'lodash/has';
import get from 'lodash/get';

import { 
  loadPromoCode, 
  createPromoCode, 
  updatePromoCode 
} from '../../shared/redux/entities/actions'


function mapStateToProps(state,props){
  const existingPromoCodeId = get(props,['match','params','promoCodeId']);

  return {
    isCreate:!existingPromoCodeId,
    needsLoading:existingPromoCodeId && !has(state,['entities','promoCodes',existingPromoCodeId]),
    existingPromoCodeId:existingPromoCodeId,
    existingPromoCode:get(state,['entities','promoCodes',existingPromoCodeId],{})
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ 
    loadPromoCode,
    createPromoCode,
    updatePromoCode 
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/ProviderPromoCodeInfo/connect.js